import { cardsBrand } from '@/components/card/constants';
import WhiteContainer from '@/components/containers/WhiteContainer';
import MeatballDropdown from '@/components/dropdown/MeatballDropdown';
import Radio from '@/components/form/Radio';
import Loading from '@/components/loading/Loading';
import { useRemovePaymentMethodMutation } from '@/redux/rtk';
import text from '@/text';
import classnames from 'classnames';
import React from 'react';
import { Dropdown } from 'react-bootstrap';

interface CardOptionProps {
  name: string;
  card: {
    id: string;
    name: string;
    brand: string;
    last4: string;
  };
  isSelected: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CardOption = ({
  isSelected,
  name,
  card,
  onChange,
}: CardOptionProps) => {
  const [removePaymentMethod, { isLoading: removeIsLoading }] = useRemovePaymentMethodMutation();
  
  return (
    <WhiteContainer className={classnames('CardOption', { isSelected })}>
      {removeIsLoading ? (
        <Loading />
      ) : (
        <>
          <Radio
            id={card.id}
            onChange={onChange}
            name={name}
            value={card.id}
            checked={isSelected}
          />
          <div className='details'>
            <div>
              <span>
                {cardsBrand[card.brand as keyof typeof cardsBrand]
                  ? cardsBrand[card.brand as keyof typeof cardsBrand]
                  : card.brand}
              </span>
              <span>{`•••• •••• •••• ${card.last4}`}</span>
            </div>
            {card.name}
          </div>
          {/* @ts-expect-error: wrong types */}
          <MeatballDropdown btnClassName='icon-button'>
            <Dropdown.Item onClick={() => removePaymentMethod({ paymentMethodId: card.id })}>
              {text('remove')}
            </Dropdown.Item>
          </MeatballDropdown>
        </>
      )}
    </WhiteContainer>
  );
};

export default CardOption;
